import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class MissionAndVisionBigBox extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get header() {
    return get(this, '_naglowek.value', '');
  }

  get slogan() {
    return get(this, '_haslo.value', '');
  }

  get description() {
    return get(this, '_tresc.value', '');
  }

  get logo() {
    return get(this, '_logo.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/MissionAndVisionBigBox.model.js